export const LISTE_DOMICILIATION_BANCAIRE = {
  title: 'Liste des domiciliations bancaires',
  actions: {
    add: 'Ajouter une domiciliation bancaire',
    search: 'Rechercher',
  },
  tab: {
    libelle: 'Libellé',
    titulaire: 'Titulaire',
    compteComptable: 'Compte comptable',
    codeJournal: 'Code journal',
    actif: 'Actif',
  },
};

export const ADD_DOMICILIATION_BANCAIRE = {
  titleAdd: 'Ajouter une domiciliation bancaire',
  titleEdit: 'Modifier domiciliation bancaire {libelle}',
  actions: {
    cancel: 'Annuler',
  },
  informationDomiciliation: {
    title: 'Domiciliation bancaire',
    libelle: 'Libellé',
    titulaire: 'Titulaire du compte',
    iban: 'IBAN',
    bic: 'BIC',
    codeBanque: 'Code banque',
    codeAgence: 'Code agence',
    numeroCompte: 'N° de compte',
    cleRib: 'Clé RIB',
    compteComptable: 'Compte comptable',
    compteEscompte: 'Compte d\'escompte',
    codeJournal: 'Code journal',
    tvaSurEscompte: 'TVA sur escompte',
    SEPA: 'Identification SEPA',
    actif: 'Actif',
    interfaceComptable: 'Interface comptable',
    libelleBanque: 'Libellé banque (Virement / SEPA)',
  },
  parametrageLibelle: {
    vente: {
      title: 'Paramétrage libellé règlement',
      ecriture: 'Libelle d’écriture de règlement',
      ecritureTiers: 'Libellé règlement ligne d’écriture de tiers',
      ecritureBanque: 'Libellé règlement ligne d’écriture de banque',
      referenceTiers: 'Libellé règlement référence de tiers',
      referenceBanque: 'Libellé règlement référence de banque',
    },
    achat: {
      title: 'Paramétrage libellé paiement',
      ecriture: 'Libelle d’écriture de paiement',
      ecritureTiers: 'Libellé paiement ligne d’écriture de tiers',
      ecritureBanque: 'Libellé paiement ligne d’écriture de banque',
      referenceTiers: 'Libellé paiement référence de tiers',
      referenceBanque: 'Libellé paiement référence de banque',
    },
    paramEcriture: {
      piece: 'Type de la pièce comptable',
      nom: 'Nom commercial du Tiers',
      reference: 'Référence de la pièce',
      nomJuridique: 'Nom juridique du tiers',
      numero: 'Numéro de règlement',
      numerosFactures: 'Numéros de factures',
      modeReglement: 'Mode de règlement',
      exit: 'Annuler',
      compteurLigne: 'Compteur de ligne pour les remises bancaires uniquement',
      numeroFacture: 'Numéro de facture',
      referenceTire: 'Référence tiré',
      referenceEcriture: 'Référence écriture',
      vide: 'Vide',
      annonceurs: 'Annonceurs',
      nature: 'Nature de règlement',
    },
  },
  domBancaireReglement: {
    title: 'Paramètrage des libellés par mode de règlement',
    actions: {
      specialiserModeReglement: 'Spécialiser un mode de règlement',
    },
    tab: {
      libelleMode: 'Libellé du mode',
      sens: 'Sens',
      libelleEcriture: 'Libellé écriture',
      libelleEcritureClient: 'Libellé ligne écriture tiers',
      libelleEcritureBanque: 'Libellé ligne écriture banque',
      referenceTiers: 'Libellé référence tiers',
      referenceBanque: 'Libellé référence banque',
    },
    popUpPrevention: {
      deleteMultiple: 'Etes-vous sûr de vouloir supprimer ces spécialisations ?',
      delete: 'Etes-vous sûr de vouloir supprimer cette spécialisation ?',
    },
    popUpCreateSpecialisation: {
      title: 'Créer une spécialisation par mode de règlement',
      sens: 'Sens',
      modeReglement: 'Mode de règlement',
      modePaiement: 'Mode de paiement',
    },
  },
  error: {
    problemOccurred: 'Un problème est survenu',
    codeGuichet: 'Code agence',
    codeBanque: 'Code Banque',
    cleRib: 'Clé RIB',
    iban: {
      length: 'La longueur de l\'IBAN n\'est pas correct',
      countryCodeUnsupported: 'Le code de pays de l\'IBAN n\'est pas supporté',
      countryCodeUpperCaseLetters: 'Le code du pays de l\'IBAN doit-être en majuscule',
      invalidCheckDigitValue: 'Les chiffres de contrôle d\' l\'IBAN sont invalides',
      genericError: 'IBAN incorrect : {code}',
    },
    bic: {
      length: 'Le bic doit contenir 8 caractères ou 11 caractères',
      branchCodeOnlyLettersOrDigit: 'Le code de la branche doit contenir seulement des lettres ou des chiffres',
      countryCodeUnsupported: 'Le code de pays du BIC n\'est pas supporté',
      genericError: 'BIC incorrect : {code}',
    },
    addSpecialisation: {
      modeReglement: 'Le mode de règlement est obligatoire',
      modePaiement: 'Le mode de paiement est obligatoire',
      specialisationAlreadyExist: 'Impossible d\'avoir deux fois le même mode de  règlement avec le même sens dans les lignes de spécialisations par mode de règlement',
    },
  },
  success: {
    add: 'La domiciliation bancaire a été ajoutée avec succès.',
    edit: 'La domiciliation bancaire a été modifiée avec succès.',
    addDomBancaireReglement: 'La ligne de spécialisation par mode de règlement a été ajoutée avec succès.',
    editDomBancaireReglement: 'La ligne de spécialisation par mode de règlement a été modifiée avec succès.',
    deleteDomBancaireReglement: 'La ligne de spécialisation par mode de règlement a été supprimée avec succès.',
    deleteMultipleDomBancaireReglement: 'Les lignes de spécialisation par mode de règlement ont été supprimées avec succès.',
  },
};

export const DETAIL_DOMICILIATION_BANCAIRE = {
  title: 'Domiciliation bancaire',
  actions: {
    edit: 'Modifier',
  },
  titulaire: 'Titulaire du compte : ',
  iban: 'IBAN :',
  rib: 'RIB :',
  bic: 'BIC :',
  codeBanque: 'Code banque :',
  codeAgence: 'Code agence :',
  numeroCompte: 'N° de compte :',
  cleRib: 'Clé RIB : ',
  compteComptable: 'Compte comptable :',
  compteEscompte: 'Compte d\'escompte :',
  codeJournal: 'Code journal :',
  tvaSurEscompte: 'TVA sur escompte :',
  actif: 'Actif :',
  interfaceComptable: 'Interface comptable :',
  SEPA: 'Identification SEPA :',
  parametrageLibelle: {
    vente: {
      title: 'Paramétrage libellé règlement',
      ecriture: 'Libelle d’écriture de règlement',
      ecritureTiers: 'Libellé règlement ligne d’écriture de tiers',
      ecritureBanque: 'Libellé règlement ligne d’écriture de banque',
      referenceTiers: 'Libellé règlement référence de tiers',
      referenceBanque: 'Libellé règlement référence de banque',
    },
    achat: {
      title: 'Paramétrage libellé paiement',
      ecriture: 'Libelle d’écriture de paiement',
      ecritureTiers: 'Libellé paiement ligne d’écriture de tiers',
      ecritureBanque: 'Libellé paiement ligne d’écriture de banque',
      referenceTiers: 'Libellé paiement référence de tiers',
      referenceBanque: 'Libellé paiement référence de banque',
    },
  },
  domBancaireReglement: {
    title: 'Paramètrage des libellés par mode de règlement',
    tab: {
      libelleMode: 'Libellé du mode',
      sens: 'Sens',
      libelleEcriture: 'Libellé écriture',
      libelleEcritureClient: 'Libellé ligne écriture tiers',
      libelleEcritureBanque: 'Libellé ligne écriture banque',
      referenceTiers: 'Libellé référence tiers',
      referenceBanque: 'Libellé référence banque',
    },
  },
};

export const POSITIONNEMENT_CHEQUE = {
  margeBas: 'Hauteur du chèque(cm)',
  taillePolice: 'Taille de police',
  date: 'Date',
  lieu: 'Lieu',
  montantChiffre: 'Montant en chiffre',
  debutMontantLettre: 'Début montant en lettre',
  finMontantLettre: 'Fin montant en lettre',
  montantLettre: 'Montant en lettre',
  ordreCheque: 'Ordre du chèque',
  x: 'x (cm)',
  y: 'y (cm)',
  cheque: 'Chèque',
  title: 'Paramètrage lettre chèque',
};
